var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("这是一个用于在电脑端进行挖矿的程序，如果你在电脑端运行程序，和其他人竞争，将会获得奖励，答案要放到币安链上面")])])}]

export { render, staticRenderFns }